import { useEffect, useState } from "react";
import { clearLocalStorageExcept, getSecureData, setSecureData, userAccessToken } from "./helpers";
import { useNavigate } from "react-router-dom";

const WithAuth = (props) => {
  const [token, setToken] = useState(userAccessToken());
  const [attemptCount, setAttemptCount] = useState(0);
  const navigate = useNavigate(); // Move useNavigate inside the component

  useEffect(() => {
    const performLogout = async () => {
      if (!token && attemptCount < 2) {
        const new_token = await getSecureData("accessToken");
        setToken(new_token);
        setAttemptCount(attemptCount + 1);
      }

      if (attemptCount >= 2) {
        await handleLogout();
      }
    };

    performLogout();
  }, [token, attemptCount]);

  const handleLogout = async () => { 
    await clearLocalStorageExcept();
    const excludedPaths = ["/", "/no-practices-found"];
    if (!excludedPaths.includes(window.location.pathname)) {
      await setSecureData("redirect", window.location.pathname + window.location.search);    
    }
    navigate("/login", { replace: true }); // Redirect to login page
  };

  if (token) {
    return { ...props.children };
  }

  return null; // Ensure nothing is rendered if logged out
};

export default WithAuth;

